<template>
  <div class="policy-page">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />

    <v-container class="py-6 py-md-12">
      <v-layout wrap>
        <v-flex xs12>
          <div class="header-section mb-6">
            <h1 class="page-title">{{ heading || "Terms & Conditions" }}</h1>
            <v-divider class="title-divider mt-2"></v-divider>
          </div>

          <div class="content-area">
            <div v-if="!dataNotFound && content" v-html="content" class="raw-html"></div>
            
            <!-- No Data State inside content area -->
            <div v-else-if="dataNotFound" class="text-center py-16">
              <v-icon size="80" color="grey lighten-3" class="mb-4">mdi-file-remove-outline</v-icon>
              <h2 class="headline grey--text text--darken-2 font-weight-medium">No Data Found</h2>
              <p class="grey--text mt-2">The requested information is currently unavailable.</p>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      content: null,
      heading: null,
      dataNotFound: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      this.dataNotFound = false;
      axios({
        method: "GET",
        url: "/policy/view",
        params: {
          name: "Terms and conditions",
        },
      }).then((response) => {
        this.appLoading = false;
        if (response.data.status) {
          if (response.data.data.name) {
            this.heading = response.data.data.name;
          }
          if (response.data.data.content) {
            this.content = response.data.data.content;
          }
        } else {
          this.dataNotFound = true;
        }
      });
    },
  },
};
</script>

<style scoped>
.policy-page {
  background-color: #ffffff;
  min-height: 80vh;
}

.page-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 28px;
  color: #2c3e50;
  text-transform: uppercase;
  text-align: left;
}

.title-divider {
  border-width: 1px;
  border-color: #eee !important;
}

.content-area {
  text-align: left;
  font-family: "sofialight", sans-serif;
  color: #4b5563;
  line-height: 1.7;
}

.raw-html {
  width: 100%;
}

.raw-html >>> p {
  margin-bottom: 16px;
}

.raw-html >>> h1, 
.raw-html >>> h2, 
.raw-html >>> h3, 
.raw-html >>> h4 {
  margin-top: 24px;
  margin-bottom: 12px;
  color: #1a202c;
  font-family: "ibmregular", sans-serif;
}

.raw-html >>> .ql-align-center {
  text-align: center;
}

.raw-html >>> .ql-align-right {
  text-align: right;
}

.raw-html >>> .ql-align-justify {
  text-align: justify;
}

.raw-html >>> ul, 
.raw-html >>> ol {
  margin-bottom: 16px;
  padding-left: 20px;
}

.raw-html >>> li {
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 22px;
  }
}
</style>
